export type SubmissionAttempt = { signature: string; id: string };

export function submissionIdentifier(
  previous: SubmissionAttempt | null,
  keep: (attempt: SubmissionAttempt) => void,
  make?: () => string,
): (signature: string) => string {
  let held = previous;
  return (signature) => {
    held = submissionFor(held, signature, make);
    keep(held);
    return held.id;
  };
}

export function submissionFor(
  previous: SubmissionAttempt | null,
  signature: string,
  make: () => string = () => crypto.randomUUID(),
): SubmissionAttempt {
  return previous?.signature === signature ? previous : { signature, id: make() };
}

export function sameReplyTarget(
  left: { kind?: string; id: string } | null,
  right: { kind?: string; id: string } | null,
): boolean {
  return left?.kind === right?.kind && left?.id === right?.id;
}

export function submissionStillOwnsDraft(
  sentShelf: string,
  currentShelf: string,
  sentAt: number,
  nowAt: number,
): boolean {
  return sentShelf === currentShelf && sentAt === nowAt;
}
